import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { STATION_TZ } from './time';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Shortcut windows for the custom range picker, all in station (Belgrade)
 * wall time and returned as epoch ms. Whole days run 00:00 → 00:00 next day.
 */
const dayStart = (d) => d.tz(STATION_TZ).startOf('day');

function wholeDay(startOfDay) {
    return { fromMs: startOfDay.valueOf(), toMs: startOfDay.add(1, 'day').valueOf() };
}

export function sameDayLastYear(nowMs) {
    return wholeDay(dayStart(dayjs(nowMs)).subtract(1, 'year'));
}

export function yesterday(nowMs) {
    return wholeDay(dayStart(dayjs(nowMs)).subtract(1, 'day'));
}

export function thisDayLastWeek(nowMs) {
    return wholeDay(dayStart(dayjs(nowMs)).subtract(7, 'day'));
}

/** Most recent completed weekend: Saturday 00:00 → Monday 00:00 (never includes today). */
export function lastWeekend(nowMs) {
    const today = dayStart(dayjs(nowMs));
    // dayjs: 0 = Sunday … 6 = Saturday. Walk back to the latest Saturday whose Monday is ≤ today.
    let sat = today.subtract((today.day() + 1) % 7, 'day'); // most recent Saturday (today if Saturday)
    if (sat.add(2, 'day').valueOf() > today.valueOf()) sat = sat.subtract(7, 'day');
    return { fromMs: sat.valueOf(), toMs: sat.add(2, 'day').valueOf() };
}

export const RANGE_SHORTCUTS = [
    { key: 'sameDayLastYear', compute: sameDayLastYear },
    { key: 'yesterday', compute: yesterday },
    { key: 'lastWeekend', compute: lastWeekend },
    { key: 'thisDayLastWeek', compute: thisDayLastWeek },
];
